import { useEffect, useState } from "react";
import { Loader2, Tag } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/apiClient";

export function SitewideSaleToggle() {
  const [enabled, setEnabled] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/promo/sitewide").then((r) => setEnabled(!!r.data?.enabled)).catch(() => setEnabled(false));
  }, []);

  const toggle = async () => {
    if (saving || enabled === null) return;
    const next = !enabled;
    setSaving(true);
    try {
      const { data } = await api.post("/admin/promo/sitewide", { enabled: next });
      setEnabled(!!data.enabled);
      toast.success(`40% OFF sitewide sale ${data.enabled ? "enabled" : "disabled"}`);
    } catch {
      toast.error("Could not update the sitewide sale.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card-soft rounded-2xl p-6 mb-6" data-testid="sitewide-sale-card">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="rounded-2xl p-3 bg-gradient-to-br from-[#f4e7c4] to-[#e6c665]/50 ring-1 ring-[#e6c665]/40">
            <Tag className="h-6 w-6 text-[#8a681c]" aria-hidden="true" />
          </div>
          <div>
            <h3 className="font-display font-bold text-lg">40% OFF Sitewide Sale</h3>
            <p className="text-sm text-muted-foreground mt-0.5 max-w-md">
              Display-only: shows the struck-through &ldquo;was&rdquo; price and &ldquo;40% OFF&rdquo; badges plus the top banner. Turn off to run BOGO as the only promotion. Does not change the price charged.
            </p>
          </div>
        </div>
        <button
          onClick={toggle}
          disabled={saving || enabled === null}
          data-testid="sitewide-sale-toggle"
          aria-pressed={!!enabled}
          className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors ${enabled ? "bg-[#c59b27]" : "bg-[#d8cba6]"}`}
        >
          <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-transform ${enabled ? "translate-x-5" : "translate-x-0.5"}`} />
        </button>
      </div>
      <p className="text-sm font-semibold mt-3" data-testid="sitewide-sale-status">
        {enabled === null ? <Loader2 className="w-4 h-4 animate-spin inline" aria-hidden="true" /> : enabled ? "Sale is ON" : "Sale is OFF"}
      </p>
    </div>
  );
}
